import { useQuery } from "react-query";

const fetchAbout = async () => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_REACT_APP_API_URL}/api/about-us`
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    return response.json();
  } catch (error) {
    console.log(error);
  }
};

export const useAbout = () => {
  const { data, isLoading } = useQuery({
    queryKey: [`about`],
    queryFn: () => fetchAbout(),
  });

  return {
    data,
    isLoading,
  };
};
